<template>
  <d-card class="mb-5 has-box-show is-border-radius-10">
    <d-card-row>
      <p class="has-text-weight-semibold mb-1 is-size-7 is-custom-grey">
        {{ $t('inclusions').capitalize() }}
      </p>
      <div v-if="inclusions.length > 0">
        <!-- Each inclusion: its name, then its précisions as a pale,
             indented note so the two never blend together -->
        <div
          v-for="(inclusion, key) in inclusions"
          :key="key"
          class="inclusion-item"
        >
          <p
            class="is-size-7 has-text-weight-medium inclusion-label"
            :class="{ 'has-notes': inclusion.notes }"
          >
            {{ modifiedString(inclusion.inclusion_label) }}
          </p>
          <div
            v-if="inclusion.notes"
            class="inclusion-notes"
            v-html="inclusion.notes"
          />
        </div>
      </div>
    </d-card-row>
  </d-card>
</template>


<script>
export default {
  props: {
    inclusions: {
      default() {
        return [];
      },
      type: Array,
    },
  },
  methods: {
    modifiedString(inputString) {
      if (
        inputString.includes("(précisez)") ||
        inputString.includes("(specify)")
      ) {
        let newString = inputString.replace("(précisez)", "");
        newString = newString.replace("(specify)", "");
        return newString.capitalize();
      }
      return inputString.capitalize();
    },
  },
};
</script>

<style scoped lang="scss">
  @import "~/scss/variables.scss";

  .inclusion-item {
    margin-bottom: 4px;
  }

  // Name underlined only when précisions follow, so the note reads as
  // belonging to it
  .inclusion-label.has-notes {
    text-decoration: underline;
    text-decoration-color: #c9c9c9;
    text-underline-offset: 3px;
  }

  .inclusion-notes {
    color: #8a8a8a;
    font-size: 0.8rem;
    line-height: 1.35;
    margin: 2px 0 8px 10px;
    padding-left: 8px;
    border-left: 2px solid #e6e6e6;

    ::v-deep p {
      margin: 0;
    }
  }
</style>
